import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
// import Search from './pages/Search';
// import State from './pages/State';
// import National from './pages/National';
// import District from './pages/District';
import Events from './pages/Events';
import Photo from './pages/Photo';
import Video from './pages/Video';
import Contact from './pages/Contact';
import Inquiry from './pages/Contact/inquiry';
import Packages from './pages/Packages';
import BrochurePage from './pages/Brochure';
import BlogPostDetails from './pages/Events/BlogPostDetails';
// import Register from './pages/Register';
// import Login from './pages/Login';
// import ForgotPassword from './pages/ForgotPassword';
// import VerifyEmail from './pages/VerifyEmail';
// import DashboardLayout from './pages/Dashboard/Layout/DashboardLayout';
// import Dashboard from './pages/Dashboard';
// import ProtectedRoute from './components/ProtectedRoute';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// import ProfileUpdateRoute from './components/ProfileUpdateRoute';
// import Articles from './pages/Dashboard/Articles';
// import NewArticle from './pages/Dashboard/NewArticle';
// import EditArticle from './pages/Dashboard/EditArticle';
// import QRCodePage from './pages/Dashboard/QRCode';
// import Download from './pages/Download/Download';
// import Notifications from './pages/Dashboard/Notifications';
// import Support from './pages/Dashboard/Support';
// import UserDetails from './pages/Dashboard/UserDetails';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth Routes */}
      {/* <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} /> */}

      {/* Public Routes */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/search" element={<Search />} /> */}
        {/* <Route path="/state" element={<State />} /> */}
        {/* <Route path="/national" element={<National />} /> */}
        {/* <Route path="/district" element={<District />} /> */}
        <Route path="/events" element={<Events />} />
        <Route path="/project-photos" element={<Photo />} />
        <Route path="/project-videos" element={<Video />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact/inquiry" element={<Inquiry />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/brochures" element={<BrochurePage />} />
        <Route path="/blog/:id" element={<BlogPostDetails />} />
        {/* <Route path="/download" element={<Download />} /> */}
      </Route>

      {/* Dashboard Routes */}
      {/* <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        {/* Make Dashboard the index route */}
        {/* <Route index element={<Dashboard />} />
        
        {/* Other dashboard routes */}
        {/* <Route path="articles" element={<Articles />} />
        <Route path="new-article" element={<NewArticle />} />
        <Route path="edit-article/:id" element={<EditArticle />} />
        <Route path="qr-code" element={<QRCodePage />} />
        <Route path="download" element={<Download />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="support" element={<Support />} />
        <Route path="user-details" element={<UserDetails />} />
      </Route> */}
    </Routes>
  );
};

export default AppRoutes;
